import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { NeedLoveFormInput } from '@/models/needLove';

export const postNLForm = async (data: NeedLoveFormInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation PostNLForm($data: NlFormInputType!) {
        postNLForm(data: $data)
      }
    `),
  });

  return response.data?.postNLForm ?? '';
};
